module.exports = __webpack_public_path__ + "img/11.0b8ca4bc.png";